import React, { useEffect, useState, useRef, useCallback } from 'react';
import {
  BookmarkIcon,
  CommentDotsIcon,
  DotsIcon,
  HeartIcon,
  DisabledCommentDotsIcon,
  HeartIconFilled,
  PostHeartIconFilled,
  PostHeartIcon,
  CommentIconFilled,
  SmallVideoIcon,
  SmallImageIcon,
  SubscriptionIcon,CloseModalIcon
} from './Icons';
import { useDispatch, useSelector } from 'react-redux';
import { selectAuthUser } from '../reducers/auth/auth.selectors';
import CarouselComponent from './CarouselComponent';
import { bookmarkToggle, deletePost, fetchFeed, likeToggle, purchasePost ,fetchFeedPost} from '../reducers/feed/feed.actions';
import Comments from './Comments';
import { Link, useLocation, useRouteMatch } from 'react-router-dom';
import { Button, Dropdown, DropdownButton } from 'react-bootstrap';
import { PROFILE, USER_PROFILE, SINGLE_POST, BOOKMARKS, ROOT } from '../constants/routes';
import TipModal from './TipModal';
import { useTranslation } from 'react-i18next';
import Loader from './Loader';
import ReportModal from './ReportModal';
import LockedContent from './LockedContent';
import NoifyModal from './NotifyModal';
import { getLaravelValidationErrors, isVideo } from '../helpers';
import PostHeader from './generic-components/post/PostHeader';
import PostAnalytics from './generic-components/post/PostAnalytics';
import PostActionItem from './generic-components/post/PostActionItem';
import ShareComponent from './generic-components/post/ShareComponent';
import PostDescription from './generic-components/post/PostDescription';
import { useHistory } from 'react-router-dom';
import { ReactComponent as PinIcon } from 'images/pin.svg';
import API from 'API';
import { renderTime } from 'utils/functions';
import AddPaymentModal from './AddPaymentModal';
import Avatar from '../components/Avatar';
import { fetchPost, registeredCard } from '../reducers/feed/feed.actions';

const Post = ({ handlePostDelete,mediaStatus,post,card, fechFeed, showHeader = true, boookmarkFunc, isFollowingProfile, onSubmit, singlePostFollowed }) => {
  const user = useSelector(selectAuthUser);
  const dispatch = useDispatch();
  const [showComments, setShowComments] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingMedia, setIsLoadingMedia] = useState(false);
  const [purchaseStep, setPurchaseStep] = useState(0);
  const [errors, setErrors] = useState([]);
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const [resp, setResp] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);
  const isHebrew = localStorage.getItem('current_language') === "he";

  const fullPostRef = useRef();
  const fullScreenButtonRef = useRef();
  const closeButtonRef = useRef();

  const [isFullScreen, setIsFullScreen] = useState(false);
  const [succesCopy, setsuccesCopy] = useState(false);
  const [openTipModal, setOpenTipModal] = useState(false);
  const match = useRouteMatch();

  const time = renderTime(post?.createdAt);
  const feedFuncs = () => {
    dispatch(fetchFeedPost(post.id)).then(resp => {
      if (resp) {
      }
    })
  }
  useEffect(() => {
    if(post.media_status === 'completed' ){
      setIsLoadingMedia(false)


    }
    else if(post.media_status !== 'completed'&& post.media_status !== 'failed'){
      setIsLoadingMedia(true)

    }

    if (location.pathname.search('/post/') >= 0) {
      setShowComments(true);
    }


  }, [post]);

  useEffect(() => {
    let closeButton = closeButtonRef?.current;
    if (closeButton) {
      document.addEventListener('mozfullscreenchange', exitHandler, false);
      document.addEventListener('MSFullscreenChange', exitHandler, false);
      document.addEventListener('webkitfullscreenchange', exitHandler, false);
      document.addEventListener('fullscreenchange', exitHandler, false);
      closeButton.addEventListener('click', toggleFullScreen);
      return () => {
        document.removeEventListener('mozfullscreenchange', exitHandler, false);
        document.removeEventListener('MSFullscreenChange', exitHandler, false);
        document.removeEventListener('webkitfullscreenchange', exitHandler, false);
        document.removeEventListener('fullscreenchange', exitHandler, false);

        closeButton.removeEventListener('click', toggleFullScreen);
      };
    }
  }, [isFullScreen, setIsFullScreen]);

  const handleClose = () => {
    setIsOpen(false);
    setErrors([]);
    window.location.reload();
  };

  const exitHandler = () => {
    if (!document.fullscreenElement) {
      setIsFullScreen(false);
    }
  };
  const handleLikeToggle = useCallback(id => {
    setResp(false);
    dispatch(likeToggle(id))
      .then(resp => {
        setResp(true);
      })
      .catch(err => {
        setIsOpen(true);
        throw err;
      });
  }, []);

  const handleBookmarkToggle = id => {
    dispatch(bookmarkToggle(id)).then(resp => {
      if (location.pathname === BOOKMARKS) {
        boookmarkFunc();
      }
    });
  };

  const toggleFullScreen = async () => {
    let elem = fullPostRef?.current;
    let fullScreenButton = fullScreenButtonRef?.current;
    let closeButton = closeButtonRef?.current;
    if (!document.fullscreenElement) {
      elem
        .requestFullscreen()
        .then(res => setIsFullScreen(true))
        .catch(err => {
          alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
        });
    } else {
      setIsFullScreen(false);
      document.exitFullscreen();
    }
  };

  const MoreMenuBtn = React.forwardRef(({ children, onClick }, ref) => (
    <div
      ref={ref}
      onClick={e => {
        e.preventDefault();
        onClick(e);
      }}
    >
      <DotsIcon width={24}>{children}</DotsIcon>
    </div>
  ));

  const notify = () => {
    return <div className="notify-copy"> Link Copied to clipboard</div>;
  };
  const handlePostEdit = id => {
    setIsLoading(true);
    history.push('/edit_post', id);
  };

  const handleHomePostDelete = async id => {
    if (window.confirm(t('This action can not be undone. Are you sure you want to delete this post?'))) {
      setIsLoading(true);
      await dispatch(deletePost(id)).finally(() => {
        setIsLoading(false);
      });
    }
  };

  const copyLink = () => {
    var dummy = document.createElement('input'),
      text =
        USER_PROFILE === match.path
          ? window.location.origin + '/post/' + post.id
          : window.location.href + 'post/' + post.id;
    dummy.classList.add('copy-input');
    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand('copy');
    setsuccesCopy(true);
    setTimeout(() => {
      setsuccesCopy(false);
      document.body.removeChild(dummy);
    }, 2000);
  };

  const unlockPost = id => {
    setPurchaseStep(2);
    dispatch(purchasePost(id)).catch(errors => {
      setErrors(getLaravelValidationErrors(errors));
      setPurchaseStep(0);
    });
  };

  const convertMS = duration => {
    const sec = parseInt(duration, 10);
    let hours = Math.floor(sec / 3600);
    let minutes = Math.floor((sec - hours * 3600) / 60);
    let seconds = sec - hours * 3600 - minutes * 60;
    if (minutes < 10) {
      minutes = '0' + minutes;
    }
    if (seconds < 10) {
      seconds = '0' + seconds;
    }
    return minutes + ':' + seconds;
  };

  return (

    <div className="post-container">
      <Loader isLoading={isLoading} height={40} size={35}>
        {showHeader  &&(
          <div className={`post-header-wrapper`}>
            {!!post?.pinnedAt && (
              <div className="pin-container d-flex">
                <PinIcon />
                <p>Pinned post</p>
              </div>
            )}

            <div className="post-header-container d-flex justify-content-between">
              {succesCopy ? notify() : <></>}
              <PostHeader showSubscribe={true} post={post} />

              <NoifyModal
                show={isOpen}
                onHide={handleClose}
                customClass="notification-modal"
                Content={'The content that you are trying to react to is no longer available'}
                title={'Content no longer avaliable'}
              />

              <div className="dots-container">
              <span className={post?.user?.id === user?.id ? 'post-time-container' : ""}>
               {time &&
                <p className="font-size-12 time-wrapper text-gray">
                 {isHebrew && time.text && time.actualTime ? ' לפניי ': ''}
                 {isHebrew && !time.text ? ' ב ': ''}

                  {typeof time.actualTime === 'number'
                    ? time.actualTime
                    :  time.actualTime
                        .split(' ')
                        .map(time => t(time))
                        .join(' ')}
                      {t(` ${time.text} `)}
                </p>
                          }
                         </span>
                {!!user && (
                  post?.user?.id === user?.id && (
                    <Dropdown alignRight={true} className={'post-header-dropdown  edit-post-dots-container posts-dropdown-cont '}>
                      <Dropdown.Toggle as={MoreMenuBtn}></Dropdown.Toggle>
                      <div className="edit-post-popup">
                        <Dropdown.Menu className={'posts-dropdown font-size-12 border-radius-modal'}>
                          <React.Fragment>
                            <Dropdown.Item onClick={e => handlePostEdit(post.id)}>{t('Edit post')}</Dropdown.Item>
                            <Dropdown.Divider />
                            {location.pathname === ROOT ? (
                              <Dropdown.Item onClick={e => handleHomePostDelete(post.id)}>{t('Delete')}</Dropdown.Item>
                            ) : (
                              <Dropdown.Item onClick={e => handlePostDelete(post.id)}>{t('Delete')}</Dropdown.Item>
                            )}
                          </React.Fragment>
                        </Dropdown.Menu>
                      </div>
                    </Dropdown>
                  )
                )}
              </div>
            </div>
            {post.body && post.body.length > 0 && <PostDescription post={post} />}
          </div>
        )}

        <div
          className={`full-post-container display-flex justify-content-center align-items-center position-relative ${
            isFullScreen ? 'zoom' : ''
          }`}
          ref={fullPostRef}
        >
          {isFollowingProfile || post?.isAuthor || singlePostFollowed ? (
            <>
            <Loader isLoadin={isLoadingMedia} height={70}>

              <CarouselComponent images={post.files} user={user} />
            </Loader>
            {isLoadingMedia &&  <p style={{textAlign:'center',color:'#79C770'}}>proccesing</p>}
            </>
          ) : (
            !isFollowingProfile && (
              <div className="home-locked-content" style={{ padding: '0 15px' }}>
                <LockedContent >
                  {post.files[0] && post.files[0].mime_type === 'video' ? (
                    <div className="d-flex mb-2 align-items-center">
                      <SmallVideoIcon
                      className={`video-hebrew`} />
                      <span className="vedeo-image-heb ml-2">
                        {post.files[0].duration === null ? '00:00' : convertMS(post.files[0].duration)}
                      </span>
                    </div>
                  ) : post.files[0] && post.files[0].mime_type === 'image' ? (
                    <div className="d-flex mb-2 align-items-center">
                      <SmallImageIcon />
                      <span className=" vedeo-image-heb ml-2">{post.files.length > 0 ? post.files.length : null}</span>
                    </div>
                  ) : null}
                  <Button
                    onClick={ () =>  setOpenTipModal(true)}
                    className={'profile-sub-btn btn btn-light px-5 mt-0 ' + (isFollowingProfile ? '' : 'unfollowing')}
                    style={{ width: '100%', borderRadius: '32px' }}
                  >
                    <span className="profile-sub-icon">
                      <SubscriptionIcon />
                    </span>
                    {t(isFollowingProfile ? 'Unsubscribe' : 'subscribe_to_see_post')}
                  </Button>
                </LockedContent>
              </div>
            )
          )}
          <div
            className={`d-flex 
             post-actions-container ${isFullScreen ? 'full-screen post-actions-container-full-screen' : ''}`}
          >
            <PostActionItem
              icon={post.liked ? PostHeartIconFilled : PostHeartIcon}
              customClass={`like-icon ${post.user.following ? 'mr-4' : 'mr-4'} `}
              onClick={() =>
                !(post.user.id === user.id) && !post.user.following ? setOpenTipModal(true) : handleLikeToggle(post.id)
              }
            />

            <PostActionItem
              icon={showComments ? CommentIconFilled : CommentDotsIcon }
              customClass={post.user.following ? 'mr-4' : 'disable-action mr-4'}
              onClick={() =>
                !(post.user.id === user.id) && !post.user.following
                  ? setOpenTipModal(true)
                  : setShowComments(!showComments)
              }
            />

            {!!user && post.user.id !== user.id && <TipModal card={card} post={post} user={post.user} />}
            <div className="bookmark-icon cursor-pointer ml-auto">
              <PostActionItem
                icon={BookmarkIcon}
                customClass={'mr-0'}
                iconClass={post.bookmarked ? 'fill-bookmark' : 'unfilled-bookmark'}
                onClick={() => handleBookmarkToggle(post.id)}
              />
            </div>

          </div>
          {openTipModal && (
            <AddPaymentModal card={card}  onSubmit={onSubmit} user={post.user} post={post} show={openTipModal} onHide={() => setOpenTipModal(false)} />
          )}


          <PostAnalytics
            setShowComments={() => setShowComments(!showComments)}
            post={post}
            isFullScreen={isFullScreen}
            user={user}
          />
        </div>
        {showComments && <Comments post={post} />}
      </Loader>
      <div className="post-sub-line"></div>

    </div>

  );
};

export default Post;
